// Compare page URI
export const COMPARE_PAGE = {
    de: '/vergleiche',
    en: '/compare',
    es: '/compara',
    fr: '/comparer',
    it: '/confronta',
};
